import { showErrorToast } from "../utils/toastHelper";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

/**
 * Helper centralizado para erros - usa o sistema moderno de toasts
 */
const toastError = err => {
	const errorMsg = err.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			showErrorToast(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
			return
		} else {
			showErrorToast(errorMsg, {
				toastId: errorMsg,
			});
			return
		}
	} if (isString(err)) {
		showErrorToast(err);
		return
	} else {
		showErrorToast("An error occurred!");
		return
	}
};

export default toastError;
